import qs from "qs";


const register = async (mentor) => {

    const resp = await fetch(`/api/public/mentors/mentor`, {
        method: 'POST',
        headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(mentor)
    });
    
    if(!resp.ok){
        throw await resp.json();
    }

    return resp;
}

const getCampus = async () => {

    const campus = await fetch(`/api/public/campus`, {
        method: 'GET',
        headers: {
            'accept': '*/*'
        }
    });

    if(campus.status != 200 && campus.status != 202){
        throw new Error;
    }

    return await campus.json();

}

const getLevels = async () => {

    const levels = await fetch(`/api/public/campus/levels`, {
        method: 'GET',
        headers: {
            'accept': '*/*'
        }
    });

    if(levels.status != 200 && levels.status != 202){
        throw new Error;
    }

    return await levels.json();

}

const getOrigins = async () => {

    const origins = await fetch(`/api/public/campus/origins`, {
        method: 'GET',
        headers: {
            'accept': '*/*'
        }
    });

    const body = await origins.json();

    return body;

}

const validateEmptyFields = (fields) => {
    const fieldsArray = Object.entries(fields);
    let returnValue = false;
    let exitLoop = false;
    let colaborador;
    let colaboradores;
    let estudiante;
    let estudiantes;
    fieldsArray.forEach(field => {
        if(exitLoop)
            return;

        switch(field[0]){
            case 'sNombre':
                if(isEmpty(field[1])){
                    returnValue = 'Debe ingresar su nombre.';
                    exitLoop = true;
                }
                break;
            case 'sCorreo':
                if(isEmpty(field[1])){
                    returnValue = 'Debe ingresar su correo.';
                    exitLoop = true;
                }
                break;
            case 'sCiudadResidencia':
                if(isEmpty(field[1])){
                    returnValue = 'Debe ingresar su ciudad de origen.';
                    exitLoop = true;
                }
                break;
            case 'sPaisResidencia':
                if(isEmpty(field[1])){
                    returnValue = 'Debe ingresar su país de origen.';
                    exitLoop = true;
                }
                break;
            case 'iNomina':
                colaborador = parseInt(fields.idOrigen);
                colaboradores = [1,3,5]
                if(colaboradores.includes(colaborador)){
                    if(isNegative(field[1])){
                        returnValue = 'La nómina debe contener un valor mayor a 0.';
                        exitLoop = true;
                    }

                    if(isEmpty(field[1])){
                        returnValue = 'Debe ingresar su nómina';
                        exitLoop = true;
                    }
                    else{
                        if(field[1].length < 7){
                            returnValue = 'La nómina debe contener 7 dígitos.';
                            exitLoop = true;
                        }
                    }
                }
                break;
            case 'iMatricula':
                estudiante = parseInt(fields.idOrigen);
                estudiantes = [2,6,7];
                if(estudiantes.includes(estudiante)){
                    if(isNegative(field[1])){
                        returnValue = 'La matrícula debe contener un valor mayor a 0.';
                        exitLoop = true;
                    }

                    if(isEmpty(field[1])){
                        returnValue = 'Debe ingresar su matrícula.';
                        exitLoop = true;
                    }
                    else{
                        if(field[1].length < 7){
                            returnValue = 'La matrícula debe contener 7 dígitos.';
                            exitLoop = true;
                        }
                    }
                }
                break;
            case 'sEmpresa':
                colaborador = parseInt(fields.idOrigen);
                colaboradores = [1,3,4,5]
                if(colaboradores.includes(colaborador)){
                    if(isEmpty(field[1])){
                        returnValue = 'Debe ingresar el nombre de la empresa para la que labora.';
                        exitLoop = true;
                    }
                }
                break;
            case 'iAntiguedad':
                const valor = parseInt(field[1]);
                
                if(valor != "NaN"){
                    colaborador = parseInt(fields.idOrigen);
                    colaboradores = [1,3,4,5]
                    if(colaboradores.includes(colaborador)){
                        if(isNegative(valor)){
                            returnValue = 'Su antiguedad debe ser mayor a 0.';
                            exitLoop = true;
                        }
                        
                        if(isEmpty(field[1])){
                            returnValue = 'Debe ingresar su antiguedad en la empresa.';
                            exitLoop = true;
                        }
                    }
                }else{
                    returnValue = "Tipo de dato incorrecto en el campo \"Años en la empresa\", favor de ingresar un número.";
                    exitLoop = true;
                }
                break;
            case 'sPuesto':
                colaborador = parseInt(fields.idOrigen);
                colaboradores = [1,3,4,5]
                if(colaboradores.includes(colaborador)){
                    if(isEmpty(field[1])){
                        returnValue = 'Debe ingresar su puesto en la empresa.';
                        exitLoop = true;
                    }
                }
                break;
            case 'sPrincipalesActividades':
                colaborador = parseInt(fields.idOrigen);
                colaboradores = [1,3,4,5]
                if(colaboradores.includes(colaborador)){
                    if(isEmpty(field[1])){
                        returnValue = 'Debe ingresar sus actividades en la empresa.';
                        exitLoop = true;
                    }
                }
                break;
            case 'sMotivos':
                if(isEmpty(field[1])){
                    returnValue = 'Debe ingresar sus motivos para querer ser mentor voluntario.';
                    exitLoop = true;
                }
                break;
        }
    })

     return returnValue;
}

const isEmpty = value => {
    if(value == undefined || value == null || value == ""){
        return true;
    }else{
        return false;
    }
}

const isNegative = value => {
    value = (typeof value === "string") ? parseInt(value) : value;

    if(value <= 0)
        return true;
    else
        return false;
}


export {
    register,
    getCampus,
    getLevels,
    getOrigins,
    validateEmptyFields
}
